import axios from 'axios';

// Instance dédiée à l'authentification : ne doit pas porter le token d'accès
// courant ni déclencher l'intercepteur de rafraîchissement de api.js.
const authApi = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL
});

// Retourne { access, refresh }
export const login = (username, password) =>
  authApi.post('auth/login', { username, password }).then(res => res.data);

// Retourne { access, refresh? } (refresh renvoyé grâce à ROTATE_REFRESH_TOKENS)
export const refreshAccessToken = (refresh) =>
  authApi.post('auth/refresh', { refresh }).then(res => res.data);
